import Autocompletes_Async from './Autocompletes_Async.vue'
import { throttle } from '@/libs/functions_utils'
import { http as _http } from '@/libs/util.js'
import { defaultFun } from '../utils'
import { AUTOCOMPLETES_ASYNC_V1 } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: AUTOCOMPLETES_ASYNC_V1,
    mixins: [ commonMixins ],
    data() {
        return {
            loading:false,
            list: []
        }
    },
    computed: {
        list_clone() {
            const hash = {}
            let {initList = [], r_d_key = 'id'} = this.field
            initList = initList || []
            const list = [ ...this.list, ...initList]
            const targetList = []
            list.forEach(item => {
               const _key = item[r_d_key]
               if (hash[_key]) {
                    return 
               }
               hash[_key] = true
               targetList.push(item)
            })
            return targetList
        },
    },
    methods: {
        getData(data) {
            const { api, handle_data } = this.field
           //  const _is_equal = items.map(item => item[item_text]).includes(data) // 列表中包含相应的数据
            // if (!data) {
            //     return 
            // }
            let { 
                 out_params,
                 search_key,
                 http = _http
                } = this.field
            out_params = out_params || {}
            search_key = search_key || 'search'
            this.loading = true
            http.get(api, {
                ...out_params,
                [search_key]: data
              }).then(data => {
               const arr = handle_data && handle_data(data) || []
               if (arr.length) {
                this.list = this.list.concat(arr)
               }
              }).finally(() => {
                this.loading = false
              })
        }
    },
    watch:{
        'field.delay':function(value) {
            if (value === 0 || value) {
                this.throttle_ac = throttle.call(this, this.getData, value)
            }
        }
    },
    mounted() {
        const delay = this.field.delay || 500
        this.throttle_ac = throttle.call(this, this.getData, delay)
        this.throttle_ac()
    },
    render(h) {
        let update_search_input = defaultFun
        const {
             key,
                // eslint-disable-next-line 
             slots,scopedSlots,delay,api,out_params, search_key,handle_data,r_d_key,
             has_placeholder = true,
             _type = 'text',
             blur = defaultFun,
             change,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
            if (params['update:search-input']) {
                update_search_input = params['update:search-input']
                delete params['update:search-input']
            }
        params.type = _type
        return h(Autocompletes_Async, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                propsg: {
                    ...params,
                    placeholder: has_placeholder ? (params.placeholder || '请输入关键字进行查找') : undefined,
                    'no-data-text':params.noDataText || '暂无数据',
                    loading:this.loading,
                    value: this.my_value[key],
                    items: this.list_clone,
                    slots: this.slots,
                    scopedSlots:  scopedSlots || {},
                },
                callBacks:data => this.throttle_ac(data)
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    const target = (this.list_clone || []).filter(item => data === item[this.field['item-value']])[0]
                    if (!change) {
                        return 
                    }
                    change(data, target)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
                'update:search-input': update_search_input
            }
        })
    }
}